import React from 'react';
import moment from 'moment';
import { titleize, humanize, unescapeHTML } from 'underscore.string';
import { sluggify } from 'utils/localization/utils';
import { t } from 'i18next';

const exceptionReporterFormatter = (cell) => {
  if (cell === 'cargomatic-automation') {
    return (
      <img
        src="/img/storm-trooper.jpg"
        alt="automation_image"
        className="icon"
        width="25"
      />
    );
  }

  return <span>{cell}</span>;
};

const slugFormatter = (cell) => <span>{t(sluggify(cell))}</span>;

const fromNowFormatter = (cell) => <span>{moment(cell).fromNow()}</span>;

const shipmentFormatter = (cell, row) => {
  if (!row.shipment) {
    return null;
  }

  return <a href={`/shipments/${row.shipment._id}`}>{cell}</a>;
};

const nameFormatter = (cell) => <span>{unescapeHTML(cell)}</span>;

const columns = [
  {
    dataField: 'shipment.shipment_id',
    text: 'Shipment ID',
    formatter: shipmentFormatter,
    sort: true,
    localizationSlug: 'SHIPMENT_ID',
  },
  {
    dataField: 'shipment.shipper_name',
    text: 'Shipper',
    formatter: nameFormatter,
    sort: true,
    localizationSlug: 'SHIPPER',
  },
  {
    dataField: 'shipper.master_account.name',
    text: 'Master Account',
    type: 'master_account',
    formatter: nameFormatter,
    localizationSlug: 'MASTER_ACCOUNT',
  },
  {
    dataField: 'shipper.status',
    sort: true,
    text: 'Account Status',
    type: 'service_watch',
    localizationSlug: 'ACCOUNT_STATUS',
  },
  {
    dataField: 'shipment.driver_name',
    text: 'Driver',
    formatter: nameFormatter,
    sort: true,
    localizationSlug: 'DRIVER',
  },
  {
    dataField: 'shipment.carrier_name',
    text: 'Carrier',
    formatter: nameFormatter,
    sort: true,
    localizationSlug: 'CARRIER',
  },
  {
    dataField: 'shipment.status',
    text: 'Shipment Status',
    type: 'status',
    sort: true,
    localizationSlug: 'SHIPMENT_STATUS',
  },
  {
    dataField: 'stop.status',
    text: 'Stop Status',
    type: 'status',
    sort: true,
    localizationSlug: 'STOP_STATUS',
  },
  {
    dataField: 'exception_type',
    text: 'Type',
    sort: true,
    formatter: slugFormatter,
    localizationSlug: 'TYPE',
  },
  {
    dataField: 'release_time',
    text: 'Created',
    formatter: fromNowFormatter,
    sort: true,
    localizationSlug: 'CREATED',
  },
  {
    dataField: 'description',
    text: 'Message',
    sort: true,
    localizationSlug: 'MESSAGE',
    headerStyle: {
      width: '15%',
    },
  },
  {
    dataField: 'reporter',
    text: 'Reporter',
    type: 'reporter',
    sort: true,
    localizationSlug: 'REPORTER',
  },
  {
    dataField: 'severity',
    text: 'Severity',
    sort: true,
    localizationSlug: 'SEVERITY',
  },
];

export default {
  columns,
};
